module.exports = __webpack_public_path__ + "img/solutions_1.3e47e534.png";